<template>
  <div class="event-logo">
    <!-- Evento com banner -->
    <div
      class="event-bg"
      :style="{
        'background-image': `url(${thumb})`
      }"
      :alt="event.nome + ' Banner'"
    />
  </div>
</template>

<script lang="ts">
import Vue, { PropType } from "vue";
import Event from "@/types/Event";

export default Vue.extend({
  props: {
    event: {
      type: Object as PropType<Event>,
      required: true,
    },
  },
  computed: {
    isMobile(): boolean {
      return this.$vuetify.breakpoint.xs;
    },
    thumb(): string {
      if (this.event.images === undefined) {
        return `https://office.ingressodevantagens.com.br/evento/${this.event.id}/imagemImpressaoOnline`;
      }

      const matches = this.event.images.filter(i => i.tag == "card-thumb");

      if (matches.length > 0) {
        return matches[0].url as string;
      }

      return `https://office.ingressodevantagens.com.br/evento/${this.event.id}/imagemImpressaoOnline`;
    },
  },
});
</script>

<style lang="scss">
.event-bg {
  background-position: center;
  background-size: cover;
  width: 100%;
  height: 100%;
  border-top-left-radius: 4px;
  border-top-right-radius: 4px;
}
</style>
